import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const TicketOutline = t0 => {
  const $ = _c(6);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M3.75 7.5C3.75 6.67157 4.39471 6 5.19 6H18.81C19.6053 6 20.25 6.67157 20.25 7.5V8.75C20.25 9.30228 19.7779 9.73056 19.2877 9.98505C18.5777 10.3537 18.09 11.1175 18.09 12C18.09 12.8825 18.5777 13.6463 19.2877 14.015C19.7779 14.2694 20.25 14.6977 20.25 15.25V16.5C20.25 17.3284 19.6053 18 18.81 18H5.19C4.39471 18 3.75 17.3284 3.75 16.5V15.25C3.75 14.6977 4.22209 14.2694 4.71225 14.015C5.42226 13.6463 5.91 12.8825 5.91 12C5.91 11.1175 5.42226 10.3537 4.71225 9.98505C4.22209 9.73056 3.75 9.30228 3.75 8.75V7.5Z" strokeLinecap="round" />;
    t2 = <path d="M8.75 6.5V17.5" strokeLinecap="round" strokeDasharray="2.6 3.2" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props) {
    t3 = <IconWrapper strokeWidth={1} {...props} variant="outline">{t1}{t2}</IconWrapper>;
    $[4] = props;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export { TicketOutline };